import { Injector } from "@angular/core";

import { createBlockScrollStrategy, createGlobalPositionStrategy, createOverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";

import { VzFile } from "@models/files/file";
import { ImageViewerComponent } from "@utils/image-viewer";
import { PdfPreviewComponent } from "@utils/pdf-preview.component";
import { stopEvent } from "@models/utils/dom-ui";

export function showFilePreview(file: VzFile, allFiles: VzFile[], injector: Injector): void {
    if (!file.pdfView && !file.imgView && !allFiles.length) {
        return;
    }

    const overlayRef = createOverlayRef(injector, {
        disposeOnNavigation: true,
        hasBackdrop: true,
        backdropClass: ['ant-fade-enter', 'ant-fade-enter-active', 'ant-image-preview-mask', 'zi1999'],
        height: '100%',
        width: '100%',
        positionStrategy: createGlobalPositionStrategy(injector),
        scrollStrategy: createBlockScrollStrategy(injector)
    });
    overlayRef.hostElement.style.zIndex = '2000';

    if (file.pdfView) {
        const portal = new ComponentPortal(PdfPreviewComponent);
        const cmpRef = overlayRef.attach(portal);
        cmpRef.instance.showPdf(file.id!, overlayRef);
    }
    else {
        const files: VzFile[] = [];
        let ind: number = -1;
        for (let i = 0; i < allFiles.length; i++) {
            // if (allFiles[i].imgView && !allFiles[i].pdfView) {
                if (ind == -1 && allFiles[i].id == file.id) {
                    ind = files.length;
                }
                files.push(allFiles[i]);
            // }
        }
        const portal = new ComponentPortal(ImageViewerComponent);
        const cmpRef = overlayRef.attach(portal);
        cmpRef.instance.showImages(files, ind, overlayRef);
    }

    overlayRef.keydownEvents().subscribe(e => {
        if (e.key == 'Escape' && !e.ctrlKey && !e.shiftKey && !e.altKey && !e.metaKey && overlayRef) {
            overlayRef.dispose();
            stopEvent(e);
        }
    });

}
